
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'OrderDetail',
  props: ['orders'],
  data: () => ({
    orderTypeItems: [ "Lab", "Medication", "Procedure", "Radiology"]
  }),
  computed: {
    order: {
      get () {
        return this.orders
      },
      set (value) {
        this.$emit('updateOrder', value)
      }
    }
  }

})
